module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"minuteSession":"{interval} minute session","secondSession":"30 second session"},"fr":{"minuteSession":"session de {interval} minute | session de {interval} minutes","secondSession":"session de 30 secondes"}}')
  delete Component.options._Ctor
}
